import { useEffect } from 'react'

import { recovered, CCPA, CMP_config, GPP, GDPR } from '../scripts/freestar.js'
import redesignedFooter from '../styles/components/footer/redesignedFooter'
import FooterSection from './FooterSection/FooterSection'
import Header from './Header/Header'

import { useAmp } from 'next/amp'
import Head from 'next/head'
import Script from 'next/script'

const Layout = ({
  hideLayout,
  children,
  navigation,
  banner,
  footerNY,
  marketingNavigation,
  weatherConditions,
  regionName
}) => {
  const isAmp = useAmp()

  const mountHeader = !isAmp && (regionName === 'newyork' || (!hideLayout && navigation))

  useEffect(() => {
    if (window) {
      window.freestar = window.freestar || {}
      window.freestar.config = window.freestar.config || {}
      window.freestar.config.disabledProducts = {
        sideWall: true,
        stickyFooter: true
      }
    }
  })

  return (
    <>
      <Head>
        {!isAmp && (
          <>
            <link rel='preload' href='//googleads.github.io/videojs-ima/dist/videojs.ima.css' type='style' />
          </>
        )}
        <>
          {/*freestar*/}
          <link rel='preconnect' href='https://a.pub.network/' crossOrigin />
          <link rel='preconnect' href='https://b.pub.network/' crossOrigin />
          <link rel='preconnect' href='https://c.pub.network/' crossOrigin />
          <link rel='preconnect' href='https://d.pub.network/' crossOrigin />
          <link rel='preconnect' href='https://btloader.com/' crossOrigin />
          <link rel='preconnect' href='https://api.btloader.com/' crossOrigin />
          <link rel='preconnect' href='https://cdn.confiant-integrations.net' crossOrigin />
        </>
      </Head>
      {mountHeader && (
        <Header
          regionName={regionName}
          navigation={navigation}
          banner={banner}
          marketingNavigation={marketingNavigation}
          weatherConditions={weatherConditions}
        />
      )}
      {children}
      {!isAmp && (
        <>
          <script src='//imasdk.googleapis.com/js/sdkloader/ima3.js'></script>
        </>
      )}
      {!hideLayout && (
        <>
          <FooterSection footer={regionName === 'newyork' ? footerNY : navigation?.footer} />
          <style jsx>{redesignedFooter}</style>
        </>
      )}

      <>
        <Script>{CCPA}</Script>
        <Script>{GDPR}</Script>
        <Script>{GPP}</Script>
        <Script>{CMP_config}</Script>
        <Script>{recovered}</Script>
      </>
    </>
  )
}

export default Layout
